var BlockView = require('views/block/base-block-view');
var MenuService = require('services/menu-service');
import AsyncBlockService from 'services/async-block-service';

var GroupView = BlockView.extend({
  regions: {
    'groups': '.groups'
  },
  load: function() {
    var group = MenuService.currentGroup || EF.groups.currentGroup(MenuService.getUnlockDay());
    this.model.set('group', group);

    AsyncBlockService.load([ 'group' ], [ 'views/block/group/group-collection-view' ]).then(([ GroupCollectionView ]) => {
      var groupCollectionView = new GroupCollectionView({
        region: 'groups',
        model: this.model,
        collection: EF.groups
      });
      this.subview('groups', groupCollectionView);
    });
  }
});

module.exports = GroupView;
